import { Box, Container, Heading } from "@chakra-ui/react";
import useSite from "../../../hooks/use-site";
import { wpStyles } from "../../../theme/wp-styles";
import GravityForms from "../../GravityForms";

const Newsletter = () => {
  const {
    newsletterSignup,
    themeGeneralSettings: {
      siteSettings: { footerFormDescription, footerFormTitle },
    },
  } = useSite();
  return (
    <Box p={{ base: 4, md: 16 }} bg={wpStyles.colors.primary}>
      <Container size="sm">
        {footerFormDescription && footerFormTitle && (
          <Box textAlign="center" mb={8} color="white">
            <Heading color="white">{footerFormTitle}</Heading>
            <Box
              dangerouslySetInnerHTML={{ __html: footerFormDescription }}
              sx={{
                a: {
                  color: "white",
                },
                "a:hover": {
                  color: "white",
                },
              }}
            />
          </Box>
        )}
        <Box
          sx={{
            "input, select": {
              fontSize: "16px",
            },
            label: {
              fontWeight: "bold",
            },
          }}
        >
          {newsletterSignup && <GravityForms form={newsletterSignup} />}
        </Box>
      </Container>
    </Box>
  );
};

export default Newsletter;
